import React from "react";
var __jsx = React.createElement;
import { SvgIcon } from "@mui/material";
export default function CalendarIcon() {
  return /*#__PURE__*/React.createElement(SvgIcon, {
    viewBox: "0 0 70 128",
    height: "24",
    width: "14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 8v34h10v-8h30V24H38V8zm48 0v34h10v-8h16v74H12V34h8V24H2v94h110V24H86V8zM20 50v10h74V50zm2 18v10h10V68zm20 0v10h10V68zm20 0v10h10V68zm20 0v10h10V68zM22 88v10h10V88zm20 0v10h10V88zm20 0v10h10V88zm20 0v10h10V88z"
  }));
}
CalendarIcon.defaultProps = {
  fontSize: "inherit"
};